<template>
  <div class="container-fluid">
    <div class="row">
      <!-- Dashboard side-bar -->
      <side-bar :start="startDate" :end="endDate"></side-bar>
      <main role="main" class="col-md-10 ml-sm-auto col-lg-10 page survey fill">
        <div class="row timeline col-lg-10">
          <div class="container-fluid timeline-sticky">
            <timeline
              ref="timeline"
              :chartId="timelineId"
              :start="startDate"
              :end="endDate"
              :datePickerStart="datePickerStart"
              :datePickerEnd="datePickerEnd"
              @update="onDateRangeUpdate"
            >
            </timeline>
          </div>
        </div>

        <page-title
          :canDownload="false"
          :title="this.$t('survey')"
          iconClasses="fas fa-battery-half"
          :isDataLoading="isLoading"
          :isTimelineDisplayed="true"
        />

        <div class="container-fluid col-lg-10">
          <div class="row">
            <div class="container">
              <div class="form-inline">
                <label for="input-device-name" class="control-label mb-3 mr-sm-3">{{
                  $t('device')
                }}</label>
                <input
                  type="text"
                  name="input-device-name"
                  class="form-control mb-3 mr-sm-3 mr-2"
                  @keyup.enter="onDeviceNameChange"
                  v-model.trim="batteryForm.device_serial"
                  :placeholder="$t('device_placeholder')"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="container">
              <battery-exploitation-chart
                v-if="downloaded"
                :site="batteryForm.site"
                :dataset="dataset"
                :chartId="chartId"
                :title="batteryTimeChartTitle"
                :xTitle="timeTitle"
                :yTitle="batteryLevelTitle"
              >
              </battery-exploitation-chart>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { utilsMixin } from '../utils/mixins'

export default {
  name: 'BatteryDevice',
  dependencies: ['technicalService'],
  mixins: [utilsMixin],
  data() {
    return {
      config: {
        format: 'DD/MM/YYYY',
        useCurrent: false,
        locale: this.$locale,
      },
      downloaded: false,
      isLoading: false,
      dataset: {},
      startDate:
        this.$route.params.start != undefined
          ? moment(this.$route.params.start, 'YYYYY-MM-DD')
          : moment().subtract(1, 'month'),
      endDate:
        this.$route.params.end != undefined
          ? moment(this.$route.params.end, 'YYYYY-MM-DD')
          : moment(),
      datePickerStart: undefined,
      datePickerEnd: undefined,
      batteryForm: {
        device_serial: this.$route.params.device ? this.$route.params.device : '',
        site: this.$route.params.site ? this.$route.params.site : 'france.chambord.chateau',
      },
      timelineId: 'timeline',
      chartId: 'batteriesChart',
      lastBatteryLevelChartId: 'lastBatteryLevelChart',
      firstBatteryLevelChartId: 'firstBatteryLevelChart',
      batteryLevelEndTitle: 'Number of sessions over battery level at the end of visit',
      batteryLevelStartTitle: 'Number of sessions over battery level at the start of visit',
      timeTitle: this.$t('filter.duration') + ' (minutes)',
      batteryLevelTitle: this.$t('battery.levels') + ' (%)',
      sessionTitle: 'Sessions (nb)',
    }
  },
  mounted() {},
  components: {
    'side-bar': () => import('./Sidebar'),
    'battery-exploitation-chart': () => import('./charts/exploitation/BatteryExploitationChart'),
    timeline: () => import('./Timeline'),
  },
  computed: {
    batteryTimeChartTitle: function() {
      return this.dataset.levels && this.dataset.levels.length > 0
        ? 'Battery level per session over time (' + this.dataset.levels.length + ' sessions)'
        : 'Battery level per session over time'
    },
  },
  methods: {
    onDateRangeUpdate: function(dateRange) {
      if (this.startDate == dateRange.start && this.endDate == dateRange.end) return

      clearTimeout(this.timeout)
      dateRange.start = moment(dateRange.start, this.dateFormat).isValid()
        ? dateRange.start
        : moment()
            .subtract(1, 'month')
            .format(this.dateFormat)
      dateRange.end = moment(dateRange.end, this.dateFormat).isValid()
        ? dateRange.end
        : moment().format(this.dateFormat)

      this.datePickerStart = dateRange.start
      this.datePickerEnd = dateRange.end

      this.startDate = dateRange.start
      this.endDate = dateRange.end

      this.timeout = setTimeout(() => {
        this.fetchBatteryLevels()
      }, 500)
    },
    onDeviceNameChange: function() {
      this.fetchBatteryLevels()
    },
    fetchBatteryLevels: function() {
      this.isLoading = true

      var start = moment(this.startDate, this.dateFormat).format('YYYY-MM-DD')
      var end = moment(this.endDate, this.dateFormat).format('YYYY-MM-DD')

      if (!start.isValid() || !end.isValid()) {
        return
      }

      window.history.pushState(
        null,
        null,
        '/battery/level/device/' +
          this.batteryForm.device_serial +
          '/site/' +
          this.batteryForm.site +
          '/start/' +
          start +
          '/end/' +
          end,
      )

      this.technicalService
        .getBatteryInformationsForDeviceAndDate(
          this.batteryForm.device_serial,
          'battery_lifetime',
          start,
          end,
        )
        .then(data => {
          this.dataset = data.result
          this.downloaded = true
          this.isLoading = false
        })
        .catch(e => {
          this.isLoading = false
          console.error('Error', e)
        })
    },
  },
}
</script>

<style>
.header-title-survey {
  padding: 1rem 0.5rem;
  text-align: center;
}

.starter-template {
  padding: 3rem 1.5rem;
  text-align: center;
}

.table > tbody > tr > td {
  vertical-align: middle;
}

.table > tbody > tr > th {
  vertical-align: middle;
}
</style>
